import '@babel/polyfill'
import './static-files/unsupported-browser/browser-compatibility'
import './logic/core/translations/i18n'
import React from 'react'
import ReactDOM from 'react-dom'

import { fetchConfiguration } from './logic/core/configuration/fetch-configuration'
import { fetchLocalizations } from './logic/core/translations/fetch-localizations'
import { internetExplorerTextEncoder } from './logic/utils/internet-explorer'
import { AppContainer } from './modules/app/app.container'

internetExplorerTextEncoder()

const NODE = document.getElementById('app')

const render = (translations, configuration) => {
  const Root = (
    <AppContainer
      translations={translations}
      configuration={configuration}
    />
  )

  ReactDOM.render(Root, NODE)
}

fetchLocalizations()
  .then((translations) =>
    fetchConfiguration()
      .then((configuration) =>
        render(translations, configuration)))

if (module.hot) {
  module.hot.accept('./')
}
